const baseUrl = 'https://bdsgallery-function.azurewebsites.net/api/builds';
let params;
let page = localStorage.getItem('gPage')? JSON.parse(localStorage.getItem('gPage')) : 1;

const getPage = (params) => {
  progress();
  $.ajax({
    url: baseUrl + params,
    type: 'GET',
    dataType: 'json',
    success: function (res) {
      let html = '';
      let paginationHtml = '';
      if (res.data && res.data.length > 0) {
        const total_page = Math.ceil(res.count / 12);
        res.data.map(item => {
          html += '<div class="build-item">' +
            '<div class="build-item-content">' +
            '<div class="build-item-title">' +
            '<a href="/pages/build?id=' + item._id + '">' +
            '<h3>' + (item.lift_height ? item.lift_height + ' Lifted ' : '') + item.year + ' ' + item.make + ' ' + item.model + '</h3></a>' +
            '</div>' +
            '</div>' +
            '<div class="build-item-thumbnail">' +
            '<a href="/pages/build?id=' + item._id + '">' +
            '<img src="' + item.images[0] + '">' +
            '</a>' +
            '</div>' +
            '<div class="build-item-meta">' +
            '<span class="imagegallery-count-image-album">' + item.username + '</span>' +
            '<div class="icon_container">' +
            '<span class="album-rating-block"><p id="album-rating" style="margin:0 15px 0 0; font-size: 15px;">' + item.votes.length + '</p><i class="fas fa-thumbs-up"></i></span>' +
            '</div>' +
            '</div><div id="rating-msg" class="thumb-status-message" style="text-align: right; margin-right: 5px; display: none;">Already voted!</div>' +
          '</div>';
        });

        $('.gallery-rte').html(html);

        const isFirstPage = parseInt(page) === 1;
        const isLastPage = parseInt(page) === total_page;

        $('.backward').prop('disabled', isFirstPage);
        $('.forward').prop('disabled', isLastPage);

        if (isFirstPage && isLastPage) {
          $('.backward, .forward').prop('disabled', true);
        }

        for (let i = 0; i < total_page; i++) {
          if (parseInt(page) === (i + 1)) {
            paginationHtml += `<a class="active">${i + 1}</a>`;
          } else {
            paginationHtml += `<a>${i + 1}</a>`;
          }
        }
        $('.main_pagination').html(paginationHtml);
      } else {
        $('.gallery-rte').html('<h3 style="margin: 30px auto;">No Builds</h3>');
        $('.backward').prop('disabled', true);
        $('.forward').prop('disabled', true);
        $('.main_pagination').html('<a class="active">1</a>');
      }
      $.unblockUI();
    },
    error: function (error) {
      console.log(error);
      $.unblockUI();
    }
  });
}

if (email !== '' && galleryAdmins.includes(email)) {
  params = '?';
} else {
  params = '?approval=1&';
}

getFitmentData('').then((data) => {
  if (Object.keys(data.result).length > 0) {
    makeGallerySearchSelect(Object.keys(data.result)[0], data.result[Object.keys(data.result)[0]]);
  }
});

params += `page=${page}`;
localStorage.setItem('gPage', page);

getPage(params);

$(document).on("click", ".main_pagination a", function () {
  params = updateQueryParam(params, 'page', $(this).text());
  page = $(this).text();
  getPage(params);
  localStorage.setItem('gPage', page);
});

$('.backward').on('click', function () {
  page = parseInt(page) - 1;
  params = updateQueryParam(params, 'page', page);
  getPage(params);
  localStorage.setItem('gPage', page);
});

$('.forward').on('click', function () {
  page = parseInt(page) + 1;
  params = updateQueryParam(params, 'page', page);
  getPage(params);
  localStorage.setItem('gPage', page);
});

$(document).on("click", ".album-rating-block", function () {
  const href = $(this).parent().parent().parent().find('a').attr('href');
  const id = href.split('?')[1].replace('id=', '');
  const userId = generateUniqueIdentifier();
  const object = $(this);
  if (userId) {
    $.ajax({
      url: baseUrl,
      type: 'POST',
      data: JSON.stringify({ id: id, userId: userId }),
      dataType: 'json',
      success: function (res) {
        if (parseInt(object.find('#album-rating').text()) === res[0].votes.length) {
          object.parent().parent().parent().find('#rating-msg').show();
          setTimeout(() => {
            object.parent().parent().parent().find('#rating-msg').hide();
          }, 3000);
        } else {
          object.find('#album-rating').text(res[0].votes.length);
        }
      }
    });
  }
});

function generateUniqueIdentifier() {
  let uniqueId = localStorage.getItem('uniqueId');

  if (!uniqueId) {
    uniqueId = generateUUID();
    localStorage.setItem('uniqueId', uniqueId);
  }

  return uniqueId;
}

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

async function getFitmentData(param) {
  const res = await fetch("https://fitmentapi.azurewebsites.net/api/search" + '?' + param, { method: "GET" });
  return res.json();
}

function makeGallerySearchSelect(id, optionArray, v) {
  if (optionArray.length > 0) {
    let html = '<option class="search_select_option">All</option>';
    optionArray.map(option => {
      if (id === 'year') {
        html += '<option class="search_select_option" ' + (option === parseInt(v)? 'selected' : '') + '>' + option + '</option>';
      } else {
        html += '<option class="search_select_option" ' + (option === v? 'selected' : '') + '>' + option + '</option>';
      }
    });
    if (id === 'year') {
      $('#search_' + id + '_from').append(html);
      $('#search_' + id + '_to').append(html);
      $('#search_' + id + '_from').removeAttr('disabled');
      $('#search_' + id + '_to').removeAttr('disabled');
    } else {
      $('#search_' + id).append(html);
      $('#search_' + id).removeAttr('disabled');
    }
  }
}

$('.search_select').on('change', function () {
  searchSelectParams($(this).attr('id').replace('search_', ''), $(this).val());
  const defaultValues = ['Make', 'Model', 'Year'];
  if (email !== '' && galleryAdmins.includes(email)) {
    params = '?';
  } else {
    params = '?approval=1&';
  }

  $('.search_select').each(function () {
    if ($(this).val() !== 'All' && !defaultValues.includes($(this).val())) {
      const key = $(this).attr('id').replace('search_', '').replace('year_', '');
      const value = $(this).val();
      params += key + '=' + value + '&';
    }
  });

  page = 1;
  getPage(params.slice(0, -1));
  $('#clearBtn').attr('disabled', false);
  localStorage.setItem('gPage', page);
});

function updateQueryParam(url, paramName, newValue) {
  const urlParts = url.split('?');
  if (urlParts.length === 2) {
    const baseUrl = urlParts[0];
    const queryString = urlParts[1];
    const params = new URLSearchParams(queryString);
    params.set(paramName, newValue);
    const updatedQueryString = params.toString();
    return `${baseUrl}?${updatedQueryString}`;
  }

  return url;
}

function searchSelectParams(id, value) {
  if (!id.includes('year')) {
    if (id === 'make') {
      $('#search_model option[class="search_select_option"]').remove();
      $('#search_year_from option[class="search_select_option"]').remove();
      $('#search_year_to option[class="search_select_option"]').remove();
      $('#search_model').attr('disabled', true);
      $('#search_year_from').attr('disabled', true);
      $('#search_year_to').attr('disabled', true);
      if (value !== 'All') {
        getFitmentData(id + '=' + value).then((data) => {
          if (Object.keys(data.result).length > 0) {
            makeGallerySearchSelect(Object.keys(data.result)[0], data.result[Object.keys(data.result)[0]]);
          }
        });
      }
    } else {
      $('#search_year_from option[class="search_select_option"]').remove();
      $('#search_year_to option[class="search_select_option"]').remove();
      $('#search_year_from').attr('disabled', true);
      $('#search_year_to').attr('disabled', true);
      if (value !== 'All') {
        getFitmentData('make=' + $('#search_make').val() + '&' + id + '=' + value).then((data) => {
          if (Object.keys(data.result).length > 0) {
            makeGallerySearchSelect(Object.keys(data.result)[0], data.result[Object.keys(data.result)[0]].reverse());
          }
        });
      }
    }
  } else {
    const selectedValue = $('#search_year_from').val();
    if (id === 'year_from') {
      $('#search_year_to').val('All');
    }
    $('#search_year_to .search_select_option').each(function () {
      if (parseInt(selectedValue) > parseInt($(this).val())) {
        $(this).addClass('hidden');
      } else {
        $(this).removeClass('hidden');
      }
    });
  }
}

$('#clearBtn').on('click', function () {
  $('.search_select .search_select_option').remove();
  $.each($('.search_select'), function () {
    if ($(this).attr('id') !== 'search_make') {
      $(this).attr('disabled', true);
    }
  });
  getFitmentData('').then((data) => {
    if (Object.keys(data.result).length > 0) {
      makeGallerySearchSelect(Object.keys(data.result)[0], data.result[Object.keys(data.result)[0]]);
    }
  });
  $(this).attr('disabled', true);
  page = 1;
  localStorage.setItem('gPage', page);
  if (email !== '' && galleryAdmins.includes(email)) {
    params = '?';
  } else {
    params = '?approval=1&';
  }
  getPage(params);
});